module.exports = __webpack_public_path__ + "img/imgb.45a9c947.png";